import { render } from "./IncidencesManualCategorizationView.vue?vue&type=template&id=44b7833d"
import script from "./IncidencesManualCategorizationView.vue?vue&type=script&lang=js"
export * from "./IncidencesManualCategorizationView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__